import React, { useEffect } from 'react'
import ReleaseTag from 'src/components/common/ReleaseTag'
import axios from 'axios'

import dataTagsCollection from './data/dataTagsCollection.json'
import dataTagsCollectionBottom from './data/dataTagsCollectionBottom.json'

interface TagsProps {
  collections: CollectionsType
  setCollectionId: React.Dispatch<
    React.SetStateAction<
      | {
          id: string | null
          name: string | null
        }
      | undefined
    >
  >
}

export const findCollectionById = (
  clusterHighlights: CollectionsType,
  id: string
) => {
  return clusterHighlights?.find((collection) => collection.id === id)
}

interface RenderCollectionTagsProps {
  collections: CollectionsType
  collectionId: { id: string | null; name: string | null } | undefined
  isNewRelease: boolean | undefined
}

interface IRenderCollectionTagsBottom {
  collections: CollectionsType
  isVivaraYou?: boolean
}

export interface ITagsData {
  [key: string]: {
    className: string
    collectionBlock?: boolean
  }
}

export function RenderCollectionTags({
  collections,
  collectionId,
  isNewRelease,
}: Readonly<RenderCollectionTagsProps>) {
  const tagsData = dataTagsCollection.tagsData as ITagsData
  const { className, collectionBlock } =
    tagsData?.[collectionId?.id ?? 'default'] ?? tagsData.default

  return (
    <div className="tags-container__product-card">
      {collections && collectionId && !collectionBlock ? (
        <ReleaseTag
          variant={`product-card-${className}`}
          name={`${collectionId?.name}`}
        />
      ) : null}
      {isNewRelease && (collectionBlock || !collectionId) ? (
        <ReleaseTag variant="product-card" name="LANÇAMENTO" />
      ) : null}
    </div>
  )
}

export function RenderCollectionTagsBottom({
  collections,
}: Readonly<IRenderCollectionTagsBottom>) {
  const { tags, tagsData } = dataTagsCollectionBottom
  const collectionDataSearch = collections?.find(
    (clusterItem) => tags?.filter((tagId) => clusterItem.id === tagId)?.length
  )

  const collectionId = collectionDataSearch?.id as keyof typeof tagsData
  const { className } = tagsData?.[collectionId] ?? {}

  return (
    <div className="tags-container__product-card-bottom">
      {collections && collectionDataSearch && (
        <ReleaseTag
          variant={`product-card-${className}`}
          name={`${collectionDataSearch?.name}`}
        />
      )}
    </div>
  )
}

export function TagsCollection({ collections, setCollectionId }: TagsProps) {
  const { tags } = dataTagsCollection

  useEffect(() => {
    if (!collections) {
      return
    }

    const idcollection = collections.find((cluster) => {
      const filterCluster = tags?.filter((e) => {
        return cluster.id === e
      })

      return filterCluster?.length > 0
    })

    setCollectionId(
      idcollection && {
        id: idcollection?.id,
        name: idcollection?.name,
      }
    )
  }, [collections])
}

export function hasSpecialNightCollection(collections: CollectionsType) {
  if (!collections) {
    return []
  }

  const ids = [
    '3224',
    '3225',
    '3226',
    '3227',
    '3228',
    '3287',
    '3288',
    '3289',
    '3290',
    '3291',
  ]

  return collections.filter((cluster) => ids.some((id) => cluster.id === id))
}

export const validateVivaraYou = async (
  idProduct: string,
  setRenderVivaraYou: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { data } = await axios.get(
    `/api/productSpecification/getProductSpecification?idProduct=${idProduct}`,
    {
      headers: {
        'Cache-Control': 'must-revalidate, max-age=10',
      },
    }
  )

  const item = data?.find(
    (specification: { Name: string }) =>
      specification?.Name?.toLowerCase() === 'vivara you'
  )

  const valueVivaraYou = item ? item.Value : undefined

  if (valueVivaraYou?.[0]?.toLowerCase() === 'sim') {
    setRenderVivaraYou(true)
  } else {
    setRenderVivaraYou(false)
  }
}
